// extracted by mini-css-extract-plugin
export default {"padding":"Signup_padding__FGSH+","content":"Signup_content__M05O8"};